// Industry categories for the per-delivery Industry field. Mirrors the CRM
// partner-profile industry dropdown (CRMPartnerProfileTab.js) — the delivery
// field is deliberately per-deal and NOT read from the CRM partner.
export const INDUSTRY_OPTIONS = [
  'Agri',
  'Bank',
  'Cement',
  'Freight',
  'Insurance',
  'IT',
  'Labor',
  'Metals',
  'Office Expenses',
  'Power Generation',
  'Steel',
  'Stock & Sale',
  'Stock monitoring',
  'Travel Expenses',
  'Various',
];
